import ContentTitle from "components/common/ContentTitle";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import { STATUS_PROCESS } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectM24SwitchMode } from "redux/modules/m24SwitchModeSlice";
import { getSmartCompany } from "redux/modules/smartCompanySlice";
import {
  clearStack,
  selectHomeTab,
  setSmartFormStep,
} from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  documentRequiredSlice,
  getDocumentRequired,
  selectCurrentSmartServiceId,
  selectSubmitSmartForm,
  submitSmartForm,
  submitSmartFormSlice,
} from "redux/modules/visaForm";

export default function UploadDocumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isSubmit, setSubmit] = useState(false);
  const { personalId } = usePersonalDetail();
  const { draftId, getSmartForm, addSmartFormState, smartform, ConditionType } =
    useSmartForm();
  const { showLoading, hideLoading } = useModalLoading();

  const userProfile = useSelector((state) => state.user.profile);
  const m24SwitchMode = useSelector(selectM24SwitchMode);
  const homTab = useSelector(selectHomeTab);
  const submitSmartFormState = useSelector(selectSubmitSmartForm);
  const smartserviceId = useSelector(selectCurrentSmartServiceId);

  const isExtension = smartform.typeDocSmartFromName === "Extension";

  const smartCompanyID = get(userProfile, "smartCompanyID", null);
  console.log("ConditionType ", ConditionType);

  // const smartserviceId =
  //   M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
  //     ?.SMART_SERVICE_ID ?? null;
  // const ConditionType =
  //   M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
  //     ?.CONDITION_TYPE ?? null;

  useEffect(() => {
    dispatch(getDocumentRequired({ smartserviceId, ConditionType }));
    dispatch(getSmartCompany(smartCompanyID));
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      showLoading();
    } else if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        dispatch(documentRequiredSlice.actions.clearAsyncState());
        dispatch(clearStack());

        if (isSubmit) {
          showLoading();
          const prepareData = [{ draftId }];
          dispatch(submitSmartForm({ detail: prepareData }));
        } else {
          dispatch(
            setSmartFormStep(
              homTab === HOME_TAB.HISTORY
                ? SMART_T_STEP.NONE
                : SMART_T_STEP.EMPLOYEE_LIST
            )
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, showLoading]);

  useEffect(() => {
    if (submitSmartFormState.isSuccess) {
      hideLoading();
      dispatch(
        setSmartFormStep(
          homTab === HOME_TAB.HISTORY
            ? SMART_T_STEP.NONE
            : SMART_T_STEP.EMPLOYEE_LIST
        )
      );
      // dispatch(setEmployeeListDocTypeTab(null))
      dispatch(submitSmartFormSlice.actions.clearAsyncState());
    } else if (submitSmartFormState.isFailure) {
      hideLoading();
      dispatch(submitSmartFormSlice.actions.clearAsyncState());
      alert(submitSmartFormState.error?.message);
    }
  }, [submitSmartFormState.isSuccess, submitSmartFormState.isFailure]);

  const onClickSubmit = () => {
    setSubmit(true);
  };

  return (
    <div>
      <ContentTitle
        title="Application Form"
        subTitle="APPLICATION FOR QUALIFICATION FOREIGN EXPERTS OR TECHNICIAN UNDER SECTION 24 "
      />
      <br />
      <UploadDucument
        isExtension={isExtension}
        isBypassAccept
        hideSummary
        nextButtonText="Finish"
        hasSubmit={smartform.statausID === STATUS_PROCESS.Draft}
        onClickSubmit={onClickSubmit}
        customTextRemark="* All documents must be affixed with a company seal and signed by the authorized person(s)"
        // onClickBack={onClickBack}
      />
    </div>
  );
}
